import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import SwitchFormListItem from "../molecules/SwitchFormListItem";
import TextFormListItem from "../molecules/TextFormListItem";
import TextSelectFormListItem from "../molecules/TextSelectFormListItem";

interface MembershipSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const MembershipSettings: React.FC<MembershipSettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [membershipLimitError, setMembershipLimitError] = React.useState(false)
    const [membershipLimitHelperText, setMembershipLimitHelperText] = React.useState("")
    const [membershipRegChargeError, setMembershipRegChargeError] = React.useState(false)
    const [membershipRegChargeHelperText, setMembershipRegChargeHelperText] = React.useState("")
    const [membershipReissueChargeError, setMembershipReissueChargeError] = React.useState(false)
    const [membershipReissueChargeHelperText, setMembershipReissueChargeHelperText] = React.useState("")
    const [membershipUpdateChargeError, setMembershipUpdateChargeError] = React.useState(false)
    const [membershipUpdateChargeHelperText, setMembershipUpdateChargeHelperText] = React.useState("")
    const [membershipUpdateLimitError, setMembershipUpdateLimitError] = React.useState(false)
    const [membershipUpdateLimitHelperText, setMembershipUpdateLimitHelperText] = React.useState("")

    return (
        <Paper sx={{ margin: "10px" }}>
            <CategoryTitle
                text="会員システム関連設定"
            />
            <List>
                <SwitchFormListItem
                    text="新規会員登録フォームにビジター顧客を選択するボタンを表示する"
                    initialValue={systemValue?.STORE_VISITORFLUG_SETTING_ENABLE ? systemValue.STORE_VISITORFLUG_SETTING_ENABLE === "ENABLE" : false}
                    onSave={value => {
                        if (onSave) {
                            onSave("STORE_VISITORFLUG_SETTING_ENABLE", value ? "ENABLE" : "DISABLE")
                        }
                    }}
                />
                <TextSelectFormListItem
                    text="会員有効期限"
                    initialValue={systemValue?.MEMBERSHIP_LIMIT ? parseInt(systemValue.MEMBERSHIP_LIMIT).toString() : ""}
                    initialValueSelect={systemValue?.MEMBERSHIP_LIMIT ? systemValue.MEMBERSHIP_LIMIT.split(" ")[1] : ""}
                    selectOptions={[
                        { label: "か月", value: "month" },
                        { label: "年", value: "year" },
                    ]}
                    onValidate={(value, selectValue) => {
                        if (isNaN(Number(value))) {
                            setMembershipLimitError(true)
                            setMembershipLimitHelperText("数値を入力してください")
                        } else {
                            setMembershipLimitError(false)
                            setMembershipLimitHelperText("")
                        }
                    }}
                    onSave={(value, selectValue) => {
                        if (onSave) {
                            onSave("MEMBERSHIP_LIMIT", value + " " + selectValue)
                        }
                    }}
                    error={membershipLimitError}
                    helperText={membershipLimitHelperText}
                />
                <TextFormListItem
                    text="入会手数料"
                    endAdornmentText="円"
                    initialValue={systemValue?.MEMBERSHIP_REG_CHARGE ? systemValue.MEMBERSHIP_REG_CHARGE : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setMembershipRegChargeError(true)
                            setMembershipRegChargeHelperText("数値を入力してください")
                        } else {
                            setMembershipRegChargeError(false)
                            setMembershipRegChargeHelperText("")
                        }
                    }}
                    onSave={value => {
                        if (onSave) {
                            onSave("MEMBERSHIP_REG_CHARGE", value)
                        }
                    }}
                    error={membershipRegChargeError}
                    helperText={membershipRegChargeHelperText}
                />
                <TextFormListItem
                    text="更新手数料"
                    endAdornmentText="円"
                    initialValue={systemValue?.MEMBERSHIP_UPDATE_CHARGE ? systemValue.MEMBERSHIP_UPDATE_CHARGE : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setMembershipUpdateChargeError(true)
                            setMembershipUpdateChargeHelperText("数値を入力してください")
                        } else {
                            setMembershipUpdateChargeError(false)
                            setMembershipUpdateChargeHelperText("")
                        }
                    }}
                    onSave={value => {
                        if (onSave) {
                            onSave("MEMBERSHIP_UPDATE_CHARGE", value)
                        }
                    }}
                    error={membershipUpdateChargeError}
                    helperText={membershipUpdateChargeHelperText}
                />
                <TextFormListItem
                    text="再発行手数料"
                    endAdornmentText="円"
                    initialValue={systemValue?.MEMBERSHIP_REISSUE_CHARGE ? systemValue.MEMBERSHIP_REISSUE_CHARGE : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setMembershipReissueChargeError(true)
                            setMembershipReissueChargeHelperText("数値を入力してください")
                        } else {
                            setMembershipReissueChargeError(false)
                            setMembershipReissueChargeHelperText("")
                        }
                    }}
                    onSave={value => {
                        if (onSave) {
                            onSave("MEMBERSHIP_REISSUE_CHARGE", value)
                        }
                    }}
                    error={membershipReissueChargeError}
                    helperText={membershipReissueChargeHelperText}
                />
                <TextSelectFormListItem
                    text="再発行可能期間"
                    initialValue={systemValue?.MEMBERSHIP_UPDATE_LIMIT ? (parseInt(systemValue.MEMBERSHIP_UPDATE_LIMIT) * -1).toString() : ""}
                    initialValueSelect={systemValue?.MEMBERSHIP_UPDATE_LIMIT ? systemValue.MEMBERSHIP_UPDATE_LIMIT.split(" ")[1] : ""}
                    selectOptions={[
                        { label: "か月(発行から)", value: "month" },
                        { label: "年(発行から)", value: "year" },
                    ]}
                    onValidate={(value, selectValue) => {
                        if (isNaN(Number(value))) {
                            setMembershipUpdateLimitError(true)
                            setMembershipUpdateLimitHelperText("数値を入力してください")
                        } else {
                            setMembershipUpdateLimitError(false)
                            setMembershipUpdateLimitHelperText("")
                        }
                    }}
                    onSave={(value, selectValue) => {
                        if (onSave) {
                            onSave("MEMBERSHIP_UPDATE_LIMIT", "-" + value + " " + selectValue)
                        }
                    }}
                    error={membershipUpdateLimitError}
                    helperText={membershipUpdateLimitHelperText}
                />
            </List>
        </Paper>
    );
}

export default MembershipSettings